import script from "./UserPdf.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPdf.vue?vue&type=script&setup=true&lang=js"

import "./UserPdf.vue?vue&type=style&index=0&id=726778b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726778b6"]])

export default __exports__